import React from "react";

const TopMetrics = React.memo(function TopMetrics({ allStats, statsLoading }) {

  const metrics = [
    { label: "Comments Last 24 Hours", value: allStats?.comments_today ?? 0, icon: "💬", color: "#4A90E2" },
    { label: "Comments All Time", value: allStats?.comments_all_time ?? 0, icon: "🗂️", color: "#50E3C2" },
    { label: "Threats Last 24 hours", value: allStats?.threats_today ?? 0, icon: "⚠️", color: "#E94E77" },
    { label: "Threats All Time", value: allStats?.threats_all_time ?? 0, icon: "🚨", color: "#F5A623" },
  ];

  return (
    <div className="topMetrics">
      {metrics.map(m => (
        <div key={m.label} className="metricCard" style={{ borderTopColor: m.color }}>
          
          <div className="metricIcon">{m.icon}</div>

          {statsLoading ? (
            <div className="metricLoadingBar"></div>
          ) : (
            <div className="metricValue">
              {(Number(m.value) || 0).toLocaleString()}
            </div>
          )}

          <div className="metricLabel">{m.label}</div>

        </div>
      ))}
    </div>
  );
});

export default TopMetrics;